var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6242_5930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.298079 6.91682C0.297753 8.09309 0.605102 9.24164 1.18952 10.254L0.242188 13.7128L3.78191 12.7847C4.76095 13.3177 5.85789 13.597 6.97261 13.597H6.97554C10.6554 13.597 13.6509 10.6026 13.6525 6.92209C13.6532 5.13861 12.9593 3.46154 11.6985 2.1998C10.438 0.938172 8.76151 0.243001 6.97527 0.242188C3.29495 0.242188 0.299653 3.23645 0.298133 6.91682",
    fill: "url(#paint0_linear_6242_5930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0600151 6.91405C0.0596353 8.13264 0.378 9.32226 0.983255 10.3709L0.00195312 13.9537L3.6686 12.9923C4.67888 13.5432 5.81635 13.8336 6.97379 13.834H6.97677C10.7887 13.834 13.8918 10.7319 13.8934 6.91958C13.8941 5.07201 13.1752 3.33466 11.8694 2.02772C10.5634 0.720946 8.827 0.00075969 6.97677 0C3.16422 0 0.0615345 3.10171 0.0600151 6.91405ZM2.24358 10.1903L2.10667 9.97294C1.53115 9.05784 1.22739 8.00035 1.22782 6.91448C1.22907 3.74576 3.80789 1.16775 6.97895 1.16775C8.5146 1.1684 9.9578 1.76704 11.0433 2.85318C12.1287 3.93943 12.726 5.38338 12.7256 6.91915C12.7242 10.0879 10.1453 12.6662 6.97677 12.6662H6.9745C5.94278 12.6657 4.93093 12.3886 4.0485 11.865L3.8385 11.7405L1.66264 12.3109L2.24358 10.1902V10.1903Z",
    fill: "url(#paint1_linear_6242_5930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24773 4.02334C5.11826 3.73558 4.982 3.72977 4.85888 3.72472C4.75805 3.72038 4.6428 3.72071 4.52765 3.72071C4.41239 3.72071 4.22513 3.76407 4.06684 3.93689C3.90839 4.10989 3.46191 4.52793 3.46191 5.37819C3.46191 6.2285 4.08122 7.05021 4.16756 7.16563C4.254 7.28083 5.36315 9.08151 7.11977 9.77424C8.57967 10.3499 8.87677 10.2354 9.19361 10.2066C9.51051 10.1778 10.2162 9.78862 10.3601 9.38507C10.5042 8.98156 10.5042 8.63569 10.461 8.56341C10.4178 8.4914 10.3025 8.44815 10.1297 8.36176C9.95683 8.27532 9.10717 7.85722 8.94877 7.79954C8.79032 7.74191 8.67512 7.71315 8.55987 7.8862C8.44461 8.05897 8.11366 8.44815 8.01278 8.56341C7.91201 8.67893 7.81114 8.69331 7.63836 8.60687C7.46542 8.52016 6.90884 8.33789 6.24851 7.74918C5.73474 7.29109 5.38789 6.72539 5.28707 6.55234C5.18625 6.37957 5.27627 6.28591 5.36293 6.19979C5.44058 6.12236 5.53581 5.99799 5.62231 5.89711C5.70848 5.79618 5.73724 5.72417 5.79487 5.60892C5.85255 5.49355 5.82368 5.39262 5.78054 5.30618C5.73724 5.21974 5.4014 4.36503 5.24773 4.02334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6242_5930",
    x1: 670.758,
    y1: 1347.31,
    x2: 670.758,
    y2: 0.242188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6242_5930",
    x1: 694.576,
    y1: 1395.37,
    x2: 694.576,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6242_5930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.895,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c77d661ab3b2fdfbab1527a64ecf6355.svg";
export { ForwardRef as ReactComponent };